
require('./common/app-message');
